import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e526d246"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<h2 data-v-e526d246>一句话流识别</h2><h4 style=\"margin-top:2rem;\" data-v-e526d246>功能介绍</h4><p style=\"margin-top:2rem;\" data-v-e526d246>对时长较短（一分钟以内）的语音进行识别，适用于智能外呼、智能客服等较短的语音交互场景中。 <strong data-v-e526d246>针对8K电话语音场景的识别。</strong></p><h4 style=\"margin-top:2rem;\" data-v-e526d246>音频要求</h4><ul style=\"margin-top:2rem;\" data-v-e526d246><li data-v-e526d246><p data-v-e526d246>时长限制：60s以内</p></li><li data-v-e526d246><p data-v-e526d246>支持音频格式：wav pcm</p></li><li data-v-e526d246><p data-v-e526d246>音频采样率：8000Hz</p></li><li data-v-e526d246><p data-v-e526d246>采样精度（位深）：16bit</p></li><li data-v-e526d246><p data-v-e526d246>声道：单声道</p></li><li data-v-e526d246><p data-v-e526d246>每次提交语音流片段：&gt;=320 Byte (建议以20ms语音为单位)</p></li></ul><h4 style=\"margin-top:2rem;\" data-v-e526d246>使用方法</h4><p style=\"margin-top:2rem;\" data-v-e526d246>1. 在本网站注册账号，注册完成后即可生成可用的token</p><p data-v-e526d246>2. 发送识别请求：按照请求说明发送请求，具体参数详见“请求参数”</p><p data-v-e526d246>3. 接收返回结果：发送请求成功后会立即收到返回响应，按JSON格式返回，具体详见“返回说明”</p><h4 style=\"margin-top:2rem;\" data-v-e526d246>服务地址</h4>", 10)
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { style: {"margin-top":"2rem"} }, "请求参数", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"2rem"} }, "1. 请求方式：webSocket", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2. 参数说明如下", -1))
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<p style=\"margin-top:1rem;\" data-v-e526d246>完整示例</p><pre data-v-e526d246>    ws://asr.talentedsoft.com:58100/dotcasr?userid=xxxx&amp;token=xxxx&amp;sid=xxxx\r\n  </pre><p style=\"margin-top:1rem;\" data-v-e526d246> ws 握手通过之后假如参数没问题系统不会返回消息<br data-v-e526d246> 假如有错误会返回消息<br data-v-e526d246> 假如正常，后续客户端可以开始发送二进制的语音流，二进制语音流要使用ws协议进行掩码<br data-v-e526d246> 当语音流结束时，发送：end，3个字符的标志通知服务器<br data-v-e526d246></p><h4 style=\"margin-top:2rem;\" data-v-e526d246>响应结果</h4><p style=\"margin-top:2rem;\" data-v-e526d246>识别成功一句话 <strong data-v-e526d246>未结束</strong> 服务器返回： {&quot;result&quot;:&quot;语音识别结果文本内容&quot;，&quot;errCode&quot;:&quot;3&quot;}</p><p data-v-e526d246>识别成功一句话 <strong data-v-e526d246>结束</strong> 服务器返回： {&quot;result&quot;:&quot;语音识别结果文本内容&quot;，&quot;errCode&quot;:&quot;0&quot;}</p><p data-v-e526d246>识别失败 服务器返回：{&quot;result&quot;:&quot;&quot;,&quot;errCode&quot;:&quot;-1&quot;,&quot;AsrRetCode&quot;:&quot;5&quot;}</p><h4 style=\"margin-top:2rem;\" data-v-e526d246>结果字段</h4>", 8)
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { style: {"margin-top":"2rem"} }, "错误代码及常见错误原因", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_el_table, {
      data: [{ type:'外网访问', 'ws': 'ws://asr.talentedsoft.com:58100/dotcasr' }],
      border: "",
      style: {"width":"100%","margin-top":"2rem"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "type",
          label: "访问类型",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "ws",
          label: "ws"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _hoisted_11,
    _hoisted_12,
    _hoisted_13,
    _createVNode(_component_el_table, {
      data: _ctx.RequestParams,
      border: "",
      style: {"width":"100%","margin-top":"1rem"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "参数名称",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "isRequired",
          label: "是否必填",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "desc",
          label: "说明"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _hoisted_14,
    _createVNode(_component_el_table, {
      data: _ctx.ResponseParams,
      border: "",
      style: {"width":"100%","margin-top":"2rem"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "字段名",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "desc",
          label: "描述"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _hoisted_22,
    _createVNode(_component_el_table, {
      data: _ctx.ErrorCodeDesc,
      border: "",
      style: {"width":"100%","margin-top":"2rem","margin-bottom":"10rem"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "errCode",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "desc",
          label: "错误原因"
        })
      ]),
      _: 1
    }, 8, ["data"])
  ], 64))
}